<script setup>
import Logo from '@/components/landing/LogoWidget.vue';
import { ref } from 'vue';

const currentYear = ref(new Date().getFullYear());
const navs = ref([
    {
        to: '',
        label: 'Product'
    },
    {
        to: '',
        label: 'Contact'
    },
    {
        to: '',
        label: 'Login'
    },
    {
        to: '',
        label: 'Register'
    }
]);
</script>

<template>
    <div class="relative z-20 landing-container mx-auto md:pt-20 md:pb-14 py-8">
        <footer class="flex items-center justify-between md:flex-row flex-col gap-8 md:gap-0">
            <div class="flex items-center md:flex-row flex-col gap-8 md:gap-0">
                <router-link to="/">
                    <Logo />
                </router-link>
                <div class="h-4 w-[1px] bg-surface-200 dark:bg-surface-800 mx-4 md:block hidden" />
                <ul class="flex items-center gap-4">
                    <li v-for="(nav, index) of navs" :key="index">
                        <router-link :to="nav.to" class="body-small hover:underline">
                            {{ nav.label }}
                        </router-link>
                    </li>
                </ul>
            </div>
        </footer>
        <div class="w-full h-[1px] bg-surface-200 dark:bg-surface-800 my-7 md:my-4" />
        <div class="text-center body-small">© {{ currentYear }} Law Firm Intelligence</div>
    </div>
</template>
